<template>
  <v-row no-gutters align="center">
    <v-col cols="auto">
      <div class="container-width px-2">
        <AssetSnapshot /></div
    ></v-col>
  </v-row>
</template>
<script>
import AssetSnapshot from "../components/AssetSnapshot";

export default {
  name: "AssetSnapshotView",
  components: { AssetSnapshot },
  data: () => ({}),
  methods: {},
  computed: {},
};
</script>
<style  scoped lang="scss">
.container-width {
  width: 794px;
  overflow-x: visible;
  overflow-y: auto;

  ::v-deep a {
    color: #0581c6 !important;
  }
}
</style>
